import { useState, useEffect } from 'react'
import dateFormat from 'functions/dateformat'
import { BASE_PATH_API, NO_IMAGE_DEFAULT } from 'constants/env'
import styles from './styles.module.sass'
import { encodeStorage, encodeStorageLatin } from 'functions/storageBase64'
import { hideLoader, showLoader } from 'store/actions/commons'
import { useStore } from 'store'
import ModalEditImage from '../Modal'
import { fileToBase64 } from 'services/commons/files'
import errorIcon from 'assets/img/error-icon.svg';

const useEditCardUser = (responseTable) => {

    const eventos = [
        { name: 'Boda', img: 'Boda.png' }, { name: 'Baby Shower', img: 'Baby_shower.png' }, { name: 'Bautizo', img: 'Bautiso.png' }, { name: 'XV Años', img: 'XV_anios.png' }, { name: 'Primera Comunión', img: 'Primera_comunion.png' }, { name: 'Aniversario', img: 'Aniversario.png' }, { name: 'Despedidas', img: 'Despedidas.png' }, { name: 'Casa Nueva', img: 'Casa_nueva.png' }, { name: 'Cumpleaños Adulto', img: 'Cumpleanios_adulto.png' }, { name: 'Cumpleaños Infantil', img: 'Cumpleanios_infantil.png' }, { name: 'Cumpleaños Niño', img: 'Cumpleanios_infantil.png' }, { name: 'Graduación', img: 'Graduacion.png' }, { name: 'Día Especial', img: 'Dia_especial.png' }
    ]
    const validateRoutes = ['/my-table']
    const [, dispatch] = useStore((state) => state.giftTable.giftTable)

    const [ response, setResponse ] = useState()
    const [ responseError, setResponseError ] = useState()
    const [ responseService, setResponseService ] = useState()
    const [ editSection, setEditSection ] = useState(false)

    const [ isNewImage, setIsNewImage ] = useState(NO_IMAGE_DEFAULT)
    const [ image, setImage ] = useState(NO_IMAGE_DEFAULT)
    const [ celebrateUSR, setCelebrateUSR ] = useState()
    const [ textMessage, setTextMessage ] = useState()
    const [ textDate, setTextDate ] = useState()
    const [ eventID, setEventID ] = useState()

    const [ editTit, setEditTit ] = useState(false)
    const [ editMess, setEditMess ] = useState(false)
    const [ editImg, setEditImg ] = useState(false)

    const [ modalImage, setModalImage] = useState(false)
    const handleClose = () => {
        setModalImage(false)
        setEditImg(false)
        setResponseError()
    }
    const editImage = () => {
        setModalImage(true)
        setEditImg(true)
    }
    const updateEvents = async ({eventID, payload}) => {
        try {
            dispatch(showLoader());
            const urlEndpoint = `${BASE_PATH_API}/gift-table/v1/gift-table/${eventID}`
            const header = {
                method: 'PATCH',
                headers: { 'Content-Type':'application/json' },
                body: JSON.stringify(payload)
            } 
            const response = await fetch(urlEndpoint, header);
            const data = await response.json();
            if(data?.data){
                setResponseService(data?.data)
            }
        } catch (error) {
            console.error('Error fetching getListCarts data:', error);
        }
    }

    useEffect(()=>{
        if(responseTable){
            setResponse( responseTable )
            setTextMessage( responseTable?.welcome_message )
            setTextDate( dateFormat(responseTable?.date) )
            setEventID( responseTable?.id )
            if(responseTable?.celebrate_labels?.length >= 1){
                // if(responseTable?.celebrate_labels?.length === 2){
                //     setCelebrateUSR( `${responseTable?.celebrate_labels[0]?.label?.value} y ${responseTable?.celebrate_labels[1]?.label?.value}` )
    
                // }else{
                //     setCelebrateUSR( `${responseTable?.celebrate_labels[0]?.label?.value} ` )
                // }
                setCelebrateUSR(responseTable?.name)
                if(responseTable?.type?.name){
                    const cosa =  eventos.filter( img => img.name === responseTable?.type?.name )
                    const defaultImg = responseTable?.image.indexOf('1647223752')
                    const imgFinal = defaultImg >= 0 ? `https://resources.sears.com.mx/medios-plazavip/swift/v1/mesaRegalos/eventos/${cosa[0]?.img}` : responseTable?.image
                    setIsNewImage( defaultImg )
                    setImage( imgFinal )
                }
            }
        }
    },[responseTable])

    useEffect(()=>{
        if(eventID){
            let ulrRoute = window.location.pathname
            let url = validateRoutes.filter( route => ulrRoute.indexOf(route) >= 0 )

            if(url.length >= 1 && response?.status === 'Open'){
                setEditSection(true)
            }else{
                setEditSection(false)
            }
            setEditMess(false)
            setEditTit(false)
            dispatch(hideLoader());
        }
    },[eventID])

    const editTittle = () => setEditTit(true)
    const editMessage = () => setEditMess(true)
    
    const updateData = (event) => {
        const {
            value,
            name
        } = event.target

        if(name === 'title'){
            setCelebrateUSR(value)
        }
        if(name === 'message'){
            setTextMessage(value)
        }
    }


    const saveTitle = () => {
        const payload = {
            gift_table: {
                name: celebrateUSR
            }
        }
        updateEvents( { eventID, payload } )
        setEditTit(false)
    }
    const saveMessage = () => {
        const payload = {
            gift_table: {
                welcome_message: textMessage
            }
        }
        updateEvents( { eventID, payload } )
        setEditMess(false)
    }
    const handleChangeImage = (fileData) => {
        const sendFileData = fileData.replace('data:','')
        const payload = {
            gift_table: {
                image: {
                    customer_image: sendFileData
                }
            }
        }
        updateEvents( { eventID, payload } )
        setImage(fileData)
        setIsNewImage(-1)
        setModalImage(false)
        setEditImg(false)
    }

    useEffect(()=>{
        if(responseService){
            if(responseService?.details){
                setResponseError(responseService?.details)
            }else{
                try{
                    if(responseService?.id){
                        encodeStorage('GIFT_TABLE_DATA', responseService)
                    }
                }catch(err){
                    if(responseService?.id){
                        encodeStorageLatin('GIFT_TABLE_DATA', responseService)
                    }
                }
            }
            dispatch(hideLoader());
        }
    },[responseService])


    return {
        response,
        responseError,
        celebrateUSR,
        textMessage,
        textDate,
        image,
        isNewImage,
        editSection,
        editTit,
        editMess,
        editImg,
        modalImage,
        updateData,
        editTittle,
        saveTitle,
        editMessage,
        saveMessage,
        handleChangeImage,
        handleClose,
        editImage
    }
}

const ContentModalUpload = (props) => {
    const {
        handleClose,
        handleChangeImage
    } = props

    const sizeMax = 1

    const [ udImage, setUdImage ] = useState()
    const [ error, setError ] = useState()

    useEffect(()=>{
        setUdImage()
    },[])
    
    const updateImage = async (event) => {
        
        const file = event.target.files[0]
        setError()
        if (!file) return;

        if(file){
            const validTypes = ['image/jpg', 'image/jpeg', 'image/png', 'image/gif'];
            if (!validTypes.includes(file.type)) {
                setError('Formato no válido. Sube JPG, PNG o GIF');
                setUdImage()
                event.target.value = '';
                return;
            }
           
            if (file.size > sizeMax * 1024 * 1024) {
                setError(`El tamaño del archivo debe ser menor a ${sizeMax}MB`);
                setUdImage()
                event.target.value = '';
                return;
            }else{
                const imageBase64 = await fileToBase64(file);
                setUdImage(imageBase64)
                setError()
            }
        }

    }
    
    const handleClick = () => {
        if(udImage){
            handleChangeImage(udImage)
        }
    }

    return(
        <div>

            <div className={styles?.headerModal}>
                <p>Subir mi foto</p>
                <span onClick={handleClose}>X</span>
            </div>

            <div>
                <h1 className={styles?.titleModal}>Carga tu foto desde cualquier lugar</h1>
                <p>Imágenes jpg o png de hasta {sizeMax} MB de tamaño</p>
                <div>
                    <div>
                        <label for="file-upload" className={styles?.customFileUpload}>
                            <input 
                                type="file" 
                                id="file-upload"
                                accept="image/jpg, image/jpeg, image/png, image/gif"
                                onChange={updateImage}
                                className={styles?.inputFile}
                            />
                            <div className={styles?.buttonUpload}>
                                <i className="fa fa-upload" /> Subir archivo
                            </div>
                        </label>
                        {error
                            ? <p className={styles?.error}>{error}</p>
                            : null
                        }
                    </div>

                    {udImage
                        ? 
                            <>
                                <img src={udImage} alt="Imagen seleccionada" className={styles?.imgFluid} />
                                <div>
                                    <button className={styles?.btnPrincipal} onClick={handleClick}>Aceptar</button>
                                </div>
                            </>
                        : null
                    }
                </div>
            </div>
        </div>
    )
}

const ContentModaError = (props) => {
    const {
        handleClose
    } = props

    return(
        <div>

            <div className={styles?.headerModal}>
                <span onClick={handleClose}>X</span>
            </div>

            <div>
                <img className={styles?.iconSuccess} src={ errorIcon } alt={'Error'} />
                <h1 className={styles?.titleModal}>Error</h1>
                <div>
                    <p className={styles?.titleModal}>Ocurrió un error, porfavor intentalo nuevamente</p>
                    <button className={styles?.btnPrincipal} onClick={handleClose}>Aceptar</button>
                </div>
            </div>
        </div>
    )
}

const CardTitleEvent = (props) => {
    const {
        responseTable
    } = props

    const {
        response,
        responseError,
        celebrateUSR,
        textMessage,
        textDate,
        image,
        isNewImage,
        editSection,
        editTit,
        editMess,
        editImg,
        modalImage,
        updateData,
        editTittle,
        saveTitle,
        editMessage,
        saveMessage,
        handleChangeImage,
        handleClose,
        editImage
    } = useEditCardUser(responseTable)


    const isMobile = 'desktop'

    return(
        response
            ?
                <>
                    <div className={ styles?.cardEvent }>
                        <div className={ `${styles.container} containerPortal` }>

                            <div className={ isNewImage >= 0 ? styles?.contImage : `${styles?.contImage} ${styles?.full}` }>
                                
                                <div className={styles?.contIm}>
                                    <img src={ image } alt={ celebrateUSR } />
                                </div>
                                {!editImg
                                    ?
                                        editSection ? <div className={styles?.editImage} onClick={editImage}></div> : null
                                    : null    
                                }
                            </div>

                            <div className={ styles?.contCardUser }>
                                <p className={ styles?.title } >
                                    {editTit
                                        ?
                                            <fieldset className={styles?.fieldset}>
                                                <input type="text" name="title" value={ celebrateUSR } onChange={updateData} />
                                                <div className={styles?.btnSave} onClick={saveTitle}>Guardar</div>
                                            </fieldset>
                                        :
                                            <div className={styles?.contDataEdit}>{ celebrateUSR } {editSection ? <span className={styles?.edit} onClick={editTittle}></span> : null}</div>
                                    }
                                </p>

                                <p className={ styles?.date } >{  textDate }</p>

                                <p className={ styles?.message } >
                                    {editMess
                                        ?
                                            <fieldset className={styles?.fieldset}>
                                                <input type="text" name="message" value={ textMessage } onChange={updateData} />
                                                <div className={styles?.btnSave} onClick={saveMessage}>Guardar</div>
                                            </fieldset>
                                        : <div className={styles?.contDataEdit}>{ textMessage } {editSection ? <span className={styles?.edit} onClick={editMessage}></span> : null}</div>
                                    }
                                </p>
                            </div>
                        </div>
                    </div>
                    {modalImage
                        ?
                            <ModalEditImage
                                onClose={handleClose} 
                                isMobile={isMobile === 'desktop' ? '' : 'full'} 
                                type={isMobile === 'desktop' ? '' : 'full'} 
                                title={'subir mi foto'} 
                                closeBody="modalPromos"
                            >
                                <ContentModalUpload
                                    handleClose={handleClose} 
                                    handleChangeImage={handleChangeImage}
                                />
                            </ModalEditImage>
                        : null
                    }
                    {responseError
                        ?
                            <ModalEditImage
                                onClose={handleClose} 
                                isMobile={isMobile === 'desktop' ? '' : 'full'} 
                                type={isMobile === 'desktop' ? '' : 'full'} 
                                title={'subir mi foto'} 
                                closeBody="modalPromos"
                            >
                                <ContentModaError
                                    handleClose={handleClose}
                                />
                            </ModalEditImage>
                        : null
                    }
                </>
            : null
    )
}

export default CardTitleEvent